import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const DAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export const scheduleSummary = (days, slots) =>
  `${days.length ? [...days].sort().map((d) => DAYS[d]).join(" · ") : "nessun giorno"} — ${slots.length} fasce`;

export function SchedulePicker({ days, slots, onChange, prefix }) {
  const toggle = (d) => onChange({ working_days: days.includes(d) ? days.filter((x) => x !== d) : [...days, d].sort() });
  const setSlot = (i, k, v) => onChange({ slots: slots.map((s, j) => (j === i ? { ...s, [k]: v } : s)) });
  return (
    <div className="space-y-4">
      <div>
        <p className="mb-2 text-xs font-semibold text-slate-600">Giorni prenotabili</p>
        <div className="flex flex-wrap gap-1.5">
          {DAYS.map((d, i) => (
            <button key={d} type="button" data-active={days.includes(i)} onClick={() => toggle(i)} data-testid={`${prefix}-day-${i}`}
              className="choice rounded-full border bg-white px-3 py-1 text-xs font-medium">{d}</button>
          ))}
        </div>
      </div>
      <div>
        <p className="mb-2 text-xs font-semibold text-slate-600">Fasce orarie prenotabili</p>
        <div className="space-y-2">
          {slots.map((s, i) => (
            <div key={i} className="flex items-center gap-2" data-testid={`${prefix}-slot-${i}`}>
              <Input type="time" value={s.start} onChange={(e) => setSlot(i, "start", e.target.value)} className="h-9" data-testid={`${prefix}-slot-start-${i}`} />
              <span className="text-slate-400">–</span>
              <Input type="time" value={s.end} onChange={(e) => setSlot(i, "end", e.target.value)} className="h-9" data-testid={`${prefix}-slot-end-${i}`} />
              <Button variant="ghost" size="icon" onClick={() => onChange({ slots: slots.filter((_, j) => j !== i) })} data-testid={`${prefix}-slot-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ))}
          <Button variant="outline" size="sm" className="rounded-full" onClick={() => onChange({ slots: [...slots, { start: "09:00", end: "11:00" }] })} data-testid={`${prefix}-slot-add`}>
            <Plus className="h-4 w-4" /> Aggiungi fascia
          </Button>
        </div>
      </div>
    </div>
  );
}
